import { allTestListGet } from "api/allTestListApi";
import React, { useEffect, useState } from "react";
import { AllTestContext } from "../store/allTestStore";
import { connect } from "react-redux";

import { Link } from "react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { arrayValidation } from "helper/validation";
import { useHistory } from "react-router";
import { sortBy } from "helper/sortBy";
import { Radio } from "antd";
import {
  setParams,
  setSortByState,
  fetchAllOfflineSyncTest,
} from "action/actions";

import { Tooltip } from "antd";

const OfflineSyncScore = (props) => {
  const history = useHistory();
  const { allTestC, dispatchAllTest } = AllTestContext();
  const [state, setState] = useState({
    selectAll: false,
    selectTest: {},
    selectAllBtn: true,
  });
  // const [myAllTest, setAllTest] = useState(allTestC.allTest);
  // const [sortType, setSortType] = useState("");
  // const [orderBy, setOrderBy] = useState("asc");
  useEffect(() => {
    // props.fetchAllOfflineSyncTest();
    allTestListGet(props.globalState, dispatchAllTest);
  }, []);

  // const handleTestClick = (test) => {
  //   dispatchAllTest({ type: "SET_SELECTED_TEST", payload: test });
  //   // history.push(`/test/${test.test_id}/${test.test_name}`);
  // };

  // for save filter state
  // let {
  //   filterProps: {
  //     testList: { filterBy, sortBy: sortByValue, orderBy },
  //   },
  //   handleSortAndOrderChange,
  // } = props;

  // console.log("sortByValue, orderBy", sortByValue, orderBy);
  // const tests = sortBy(sortType, allTestC.allTest, orderBy);
  // useEffect(() => {
  //   allTestC.allTest && setTests(sortBy("group", allTestC.allTest, orderBy));
  // }, [allTestC.allTest]);
  // if (!sortByValue) sortByValue = "group";
  const tests = allTestC.allTest;

  // console.log("test.js allTestC", allTestC);

  //const accessType = localStorage.getItem("accessType");
  const accessType = JSON.parse(localStorage.getItem("accessType"));

  // for coordinate hide
  // const accessType = "94";

  // const handleCheckAll = async (e) => {
  //   await setState({
  //     ...state,
  //     selectAll: e.target.checked,
  //     // selectAllBtn: e.target.checked,
  //   });
  // };

  // useEffect(() => {
  //   if (state.selectAllBtn || state.selectAll) {
  //     let selectTest = {};
  //     if (state.selectAll) {
  //       Object.assign(
  //         selectTest,
  //         allTestC.allTest.map((test) => {
  //           return { test_id: test.test_id };
  //         })
  //       );
  //     }

  //     setState({
  //       ...state,
  //       selectTest,
  //     });
  //   }
  // }, [state.selectAll]);

  // const handleCheckbox = async (e, i, testChecked) => {
  //   let selectTest = { ...state.selectTest };

  //   if (e.target.checked) {
  //     selectTest[i] = testChecked;
  //   } else {
  //     delete selectTest[i];
  //   }

  //   await setState({
  //     ...state,
  //     selectTest: selectTest,
  //   });
  // };

  // useEffect(() => {
  //   if (Object.keys(state?.selectTest)?.length === tests?.length) {
  //     setState({
  //       ...state,
  //       selectAll: true,
  //       selectAllBtn: true,
  //     });
  //   } else {
  //     setState({
  //       ...state,
  //       selectAllBtn: false,
  //       selectAll: false,
  //     });
  //   }
  // }, [state.selectTest]);

  return (
    <Container className="mb-4 mt-4 container-width-fix">
      <Card className="">
        <CardBody className="responsive-custom-card-body">
          <Row>
            <div
              className="responsive-test-card-header"
              // style={{
              //   display: "flex",
              //   justifyContent: "space-between",
              //   width: "95%",
              // }}
            >
              <div className="">
                <h3
                  style={{
                    color: "#444",
                  }}
                >
                  Test List
                </h3>
              </div>

              <div
                className=""
                style={{
                  display: "flex",
                }}
              >
                {/* <select
                  // onChange={(e) => {
                  //   setSortType(e.target.value);
                  // }}
                  onChange={(e) =>
                    handleSortAndOrderChange({
                      pageName: "testList",
                      sortBy: e.target.value,
                      filterBy,
                      orderBy,
                    })
                  }
                  value={sortByValue || "group"}
                  className="form-control mb-3 form-control-sm ml-2 mr-2"
                  placeholder="Sort By"
                >
                  <option value="NA">--- Sort By ---</option>
                  <option value="testName">Name</option>
                  <option value="group">Group</option>
                  <option value="actionTag">Action Tag</option>
                </select>
                <Radio.Group
                  // onChange={(e) => {
                  //   setOrderBy(e.target.value);
                  // }}
                  onChange={(e) =>
                    handleSortAndOrderChange({
                      pageName: "testList",
                      sortBy: sortByValue,
                      filterBy,
                      orderBy: e.target.value,
                    })
                  }
                  value={orderBy}
                  optionType="button"
                  buttonStyle="solid"
                  className={"rad-btns"}
                >
                  <Radio.Button
                    className={`radio-btn-ctm `}
                    buttonStyle="solid"
                    value={"asc"}
                  >
                 
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      fill="currentColor"
                      className="bi bi-arrow-down"
                      viewBox="0 0 16 16"
                      style={{ coloe: "#fff" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                      />
                    </svg>
                  </Radio.Button>
                  <Radio.Button
                    className={`radio-btn-ctm`}
                    buttonStyle="solid"
                    value={"dsc"}
                  >
              
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      fill="currentColor"
                      className="bi bi-arrow-up"
                      viewBox="0 0 16 16"
                      style={{ coloe: "#fff" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                      />
                    </svg>
                  </Radio.Button>
                </Radio.Group> */}
              </div>
            </div>

            {Object.keys(state.selectTest).length > 0 && (
              <div
                className="text-center border p-2 rounded d-flex align-items-center"
                style={{ height: "40px" }}
              >
                {/* <div className="display-3 text-primary">{getQueryStringValue("s")}</div> */}
                <div
                  className="h4 d-flex align-items-center"
                  style={{ fontSize: "17px" }}
                >
                  Total Test
                </div>
                {"  "}
                <div
                  className="h4 text-primary ml-1"
                  style={{ fontWeight: "bold", fontSize: "17px" }}
                >
                  {Object.keys(state.selectTest).length}
                </div>
              </div>
            )}

            <Col md="12">
              <div className="pr-2">
                <FormGroup>
                  {/* <Input
                    // onKeyUp={this.filterStudent}
                    bsSize="sm"
                    // id="exampleFormControlInput1"
                    placeholder="Search Test"
                    // type="email"
                  /> */}
                  {/* <select
                    // onChange={this.changeLevel}
                    className="form-control mt-2 mb-3 form-control-sm "
                  >
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select> */}
                </FormGroup>
                <div style={{ height: "80vh", overflowY: "auto" }}>
                  <table className="table  table-striped">
                    <thead>
                      <tr>
                        <th className="small py-2 ">Test Name</th>
                        {/* <th className="small py-2">G-Coordinate</th> */}
                        {/* Hide G-Coordinate column when accessType === "94" */}

                        <th className="small py-2">MAPPR Group</th>
                        <th className="small py-2">Action Tag</th>
                        <th className="small py-2">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {arrayValidation(tests) &&
                        tests.map((test, index) => {
                          return (
                            <tr
                              key={index}
                              className="test-name-accessor"
                              style={{ cursor: "pointer" }}
                              // onClick={() => handleTestClick(test)}
                            >
                              <td className="py-2 test-name-accessor d-flex">
                                <Tooltip title={test.intro3}>
                                  <span className="test-name-span" style={{}}>
                                    {test.test_name}
                                  </span>
                                </Tooltip>
                              </td>

                              <td
                                className="py-2"
                                style={{
                                  fontWeight: "500",
                                  color: "#000",
                                }}
                              >
                                {test.group_name}
                              </td>
                              <td
                                className="py-2"
                                style={{
                                  fontWeight: "400",
                                }}
                              >
                                {test.action_tag}
                              </td>
                              <td
                                className="py-2"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                <Link to={`/sync-result`}>
                                  <div
                                    style={{ color: "#1890ff" }}
                                    onClick={() => {
                                      props.handleSetParams({
                                        testId: test.test_id,
                                        testName: test.test_name,
                                      });
                                    }}
                                    onContextMenu={() => {
                                      props.handleSetParams({
                                        testId: test.test_id,
                                        testName: test.test_name,
                                      });
                                    }}
                                  >
                                    View{" "}
                                    <i
                                      class="fa fa-arrow-right"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                </Link>
                                {/* <a
                                  // onClick={(e) =>
                                  //   props.setTestData(
                                  //     e,
                                  //     {
                                  //       name: test.test_name,
                                  //       score: test.score,
                                  //     },
                                  //     `/test/${props.uid}/${test.test_id}/${props.gid}?d=sdasadsbd3432j4hj341j34gjk3jkhfjw99h uhjkjsdsd 4 hg4hjh879798s79sd7sa7d&n=${test.test_name}&s=${test.score}&ts=${test.status}`
                                  //   )
                                  // }
                                  href={`/test/${test.test_id}/${test.test_name}`}
                                  // href={`/test-list/${test.test_name}`}
                                  onClick={(e) => {
                                    // props.history.push(
                                    //   `/test/${test.test_id}/${test.test_name}`
                                    //   // `/test-list/${test.test_name}`
                                    // );
                                    props.handleSetParams({
                                      testId: test.test_id,
                                      testName: test.test_name,
                                    });
                                  }}
                                  // style={{ color: "#1890ff" }}
                                >
                                  View{" "}
                                  <i
                                    class="fa fa-arrow-right"
                                    aria-hidden="true"
                                  ></i>
                                </a> */}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Container>
  );
};

const mapToProp = (state) => {
  return {
    globalState: state.globaReducer,
    filterProps: state.filterStateReducer,
    allTest: state.offlineSyncReducer.allTest,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleSetParams: (params) => dispatch(setParams(params)),
    handleSortAndOrderChange: (data) => dispatch(setSortByState(data)),
    fetchAllOfflineSyncTest: () => dispatch(fetchAllOfflineSyncTest()),
  };
};

export default connect(mapToProp, mapDispatchToProps)(OfflineSyncScore);
